import { FC } from 'react'
import Layout from './layout'
import Home from './pages/Home'
import { createBrowserRouter, redirect, RouterProvider } from 'react-router-dom'
import { GlobalProvider } from './GlobalContext'
import AboutUs from './pages/AboutUs/AboutUs'
import GalleryScreen from './pages/Gallery/Gallery'
import MenuAdmin from './pages/MenuAdmin/MenuAdmin'
import Login from './pages/Login/Login'
import ProtectedRoute from './auth/ProtectedRoute'
import { AuthProvider } from './auth/AuthContext'
import { SpeedInsights } from '@vercel/speed-insights/react'

const router = createBrowserRouter([
   {
      element: <Layout />,
      children: [
         {
            path: '/',
            element: <Home />,
         },
         {
            path: '/about-us',
            element: <AboutUs />,
         },
         {
            path: '/gallery',
            element: <GalleryScreen />,
         },
         {
            path: '/copy',
            loader: () => redirect('/'),
         },
         {
            element: <ProtectedRoute />,
            children: [
               {
                  path: '/menu-admin',
                  element: <MenuAdmin />,
               },
            ],
         },
         {
            path: '/login',
            element: <Login />,
         },
         {
            path: '/admin',
            loader: () => redirect('https://bobofranco.vercel.app/admin'),
         },
         {
           path: '/form',
           loader: () => redirect('https://bobofranco.vercel.app'),
         },
         {
            path: '*',
            loader: () => redirect('/'), // Yanlış URL'lerde Home sayfasına yönlendir
         },
      ],
   },
])

const App: FC = () => (
   <GlobalProvider>
      <AuthProvider>
         <RouterProvider router={router} />
         <SpeedInsights />
      </AuthProvider>
   </GlobalProvider>
)
export default App
